<template>
  <teleport to="#teleport-modal">
    <transition name="fade">
      <div
        v-show="showDialog"
        v-body-scroll-lock="showDialog === true"
        class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50"
        style="background: rgba(152, 163, 190, 0.3)"
      >
        <div class="bg-white p-8 rounded-lg" style="min-width: 480px">
          <div
            class="font-semibold text-base text-gray-92 leading-5 mb-4"
            :class="[titleClass ? titleClass : '']"
          >
            {{ title }}
          </div>
          <div class="font-light text-gray-92 leading-6 pb-4 h-auto">
            <slot></slot>
          </div>
          <div v-if="typeof okText === 'undefined'" class="text-right">
            <button
              class="bg-secondary-main font-semibold text-white leading-10 px-10 rounded focus:outline-none hover:button"
              @click="this.$emit('close-dialog')"
            >
              閉じる
            </button>
          </div>
          <div v-else class="text-right">
            <button
              class="leading-10 font-semibold px-6 rounded mr-2 focus:outline-none hover:button"
              :class="[
                closeTextColorClass ? closeTextColorClass : 'text-white',
                closeTextBgClass ? closeTextBgClass : 'bg-secondary-main',
                closeTextBorderClass ? closeTextBorderClass : '',
              ]"
              @click="this.$emit('close-dialog')"
            >
              {{ closeText || '閉じる' }}
            </button>
            <button
              class="leading-10 font-semibold px-12 rounded"
              :class="[
                okTextColorClass ? okTextColorClass : 'text-white',
                okTextBgClass ? okTextBgClass : 'bg-secondary-main',
                okTextBorderClass ? closeTextBorderClass : '',
                disabled ? 'cursor-auto' : 'focus:outline-none hover:button',
              ]"
              :disabled="disabled"
              @click="this.$emit('ok-action')"
            >
              {{ okText }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
<script>
export default {
  props: {
    showDialog: Boolean,
    title: String,
    titleClass: String,
    closeText: String,
    closeTextColorClass: String,
    closeTextBgClass: String,
    closeTextBorderClass: String,
    okText: String,
    okTextColorClass: String,
    okTextBgClass: String,
    okTextBorderClass: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-dialog', 'ok-action'],
};
</script>
